import { render, staticRenderFns } from "./Form16StyleOfProceeding.vue?vue&type=template&id=d5c19f66&scoped=true"
import script from "./Form16StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form16StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form16StyleOfProceeding.vue?vue&type=style&index=0&id=d5c19f66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c19f66",
  null
  
)

export default component.exports